import { render, staticRenderFns } from "./HotIndustryList.vue?vue&type=template&id=6d609439&"
import script from "./HotIndustryList.vue?vue&type=script&lang=js&"
export * from "./HotIndustryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports